import React, { useEffect, useRef, useState } from "react";
import {
  Person,
  Search,
  Cart3,
  Dash,
  Plus,
  X,
  Phone,
  Check2,
  ChevronDown,
  ChevronRight,
  ChevronLeft,
} from "react-bootstrap-icons";
import {
  createCustomerSerachStoreOwner,
  getAllCustomerSerachStoreOwner,
} from "../../services/storeOwnerOrderServices";
import { decryptData } from "../../utils/crypto";
import Utils from "../../utils";
import { formatCurrencyINR } from "../../utils/function";
import { getCustomerProductList } from "../../services/customerServices";
import CONFIG from "../../config";
import { notify } from "../../components/Common/Alerts";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useConfig } from "../../components/Context/ConfigContext";

const NewOrderStoreCard = ({
  cart,
  setCart,
  customerData,
  setCustomerData,
  setOrderModel,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { configData } = useConfig();
  const wrapperRef = useRef(null);
  const debounceRef = useRef(null);
  const mobileRef = useRef(null);
  const nameRef = useRef(null);

  const storedData = JSON.parse(localStorage.getItem(CONFIG.login_data));
  const [query, setQuery] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [productQuery, setProductQuery] = useState("");
  const [customerList, setCustomerList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [newCustomer, setNewCustomer] = useState({ name: "", mobile: "" });
  const [errors, setErrors] = useState({
    name: "",
    mobile: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedUnits, setSelectedUnits] = useState({});
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [inputValues, setInputValues] = useState({});
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  useEffect(() => {
    const data = {
      store_id: storedData?.active_store_id,
      category_ids: [],
      search: "",
      page: "",
      limit: 10,
    };

    getCustomerProductList(data)
      .then((response) => {
        const decrypted = decryptData(response.data.data);
        setProductList(decrypted.data);
      })
      .catch((err) => {
        notify.error(Utils.getErrorMessage(err));
      });
  }, []);

  const fetchCustomerData = async (searchValue = "") => {
    setLoading(true);
    try {
      const data = {
        search: searchValue || "",
        page: "",
        limit: "",
      };

      const response = await getAllCustomerSerachStoreOwner(data);
      const decrypted = decryptData(response.data.data);

      setCustomerList(decrypted.data);
    } catch (err) {
      notify.error(Utils.getErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchCustomerData();
  // }, [query]);

  useEffect(() => {
    let data = { search: "", page: 1, limit: 10 };
    getAllCustomerSerachStoreOwner(data)
      .then((response) => {
        const decrypted = decryptData(response.data.data);
        setCustomerList(decrypted.data);
      })
      .catch((err) => {
        notify.error(Utils.getErrorMessage(err));
      });
  }, []);

  const isMobileInput = (value) => {
    return /^\d+$/.test(value);
  };

  const handleCustomerInput = (e) => {
    const value = e.target.value;

    setSelectedCustomer(null);
    setQuery(value);

    if (isMobileInput(value)) {
      setNewCustomer((prev) => ({
        ...prev,
        mobile: value,
        name: "",
      }));
    } else {
      setNewCustomer((prev) => ({
        ...prev,
        name: value,
        mobile: "",
      }));
    }

    setIsOpen(value.length > 0);

    clearTimeout(debounceRef.current);

    debounceRef.current = setTimeout(() => {
      fetchCustomerData(value);
    }, 500); // 500ms delay
  };

  const handleSelectCustomer = (item) => {
    setSelectedCustomer(item);
    setQuery(item.mobile);
    setCustomerData(item);
    setIsOpen(false);
  };

  // const addToCart = (product) => {
  //   setCart((prev) => {
  //     const exist = prev.find((item) => item.id === product.id);

  //     if (exist) {
  //       setInputValues((prevInput) => ({
  //         ...prevInput,
  //         [product.id]: String(exist.qty + 1),
  //       }));

  //       return prev.map((item) =>
  //         item.id === product.id ? { ...item, qty: item.qty + 1 } : item,
  //       );
  //     }

  //     setInputValues((prevInput) => ({
  //       ...prevInput,
  //       [product.id]: "1",
  //     }));

  //     return [...prev, { ...product, qty: 1, unit: product.name }];
  //   });

  //   setProductQuery("");
  // };

  const addToCart = (product) => {
    setCart((prev) => {
      const exist = prev.find((item) => item.id === product.id);

      const unit =
        product.units?.find((u) => u.default_unit === 1) || product.units?.[0];

      const minValue = Number(unit?.unit_qty || 1);

      if (exist) {
        const newQty = exist.qty + minValue;

        setInputValues((prevInput) => ({
          ...prevInput,
          [product.id]: String(newQty),
        }));

        return prev.map((item) =>
          item.id === product.id
            ? {
                ...item,
                qty: newQty,
                calculated_total: calculateItemTotal(item, newQty, unit),
              }
            : item,
        );
      }

      setInputValues((prevInput) => ({
        ...prevInput,
        [product.id]: String(minValue),
      }));

      return [
        ...prev,
        {
          ...product,
          qty: minValue,
          variant_id: unit?.variant_id,
          variant_id: unit?.variant_id,
          unit_name: unit?.unit_name,
          unit_qty: unit?.unit_qty,
          unit_short_name: unit?.short_name,
          calculated_total: calculateItemTotal(product, minValue, unit),
        },
      ];
    });

    setProductQuery("");
  };

  const updateSubtotal = (id, value) => {
    setCart((prev) =>
      prev.map((c) => {
        if (c.id !== id) return c;

        return {
          ...c,
          manual_total: value === "" ? null : Number(value),
        };
      }),
    );
  };

  const updateCart = (item, change, unit) => {
    setCart((prev) => {
      const existing = prev.find((c) => c.id === item.id);

      if (existing) {
        let newQty = Number(existing.qty || 0) + change;

        // const minValue = Number(unit.min_value || 1);

        if (newQty <= 0) {
          return prev.filter((c) => c.id !== item.id);
        }

        const total = calculateItemTotal(item, newQty, unit);

        return prev.map((c) =>
          c.id === item.id
            ? {
                ...c,
                qty: newQty,
                calculated_total: total,
              }
            : c,
        );
      }

      const qty = Number(unit.unit_qty || 1);
      const total = calculateItemTotal(item, qty, unit);

      return [
        ...prev,
        {
          ...item,
          qty,
          variant_id: unit.variant_id,
          variant_id: unit.variant_id,
          unit_name: unit.unit_name,
          unit_qty: unit.unit_qty,
          unit_short_name: unit.short_name,
          selling_price: Number(unit.selling_price),
          calculated_total: total,
        },
      ];
    });
  };

  const handleCartQtyInput = (item, unit, value) => {
    if (value === "") {
      setInputValues((prev) => ({
        ...prev,
        [item.id]: "",
      }));

      setCart((prev) =>
        prev.map((c) => (c.id === item.id ? { ...c, qty: 0 } : c)),
      );

      return;
    }

    const qty = Number(value);

    setInputValues((prev) => ({
      ...prev,
      [item.id]: value,
    }));

    setCart((prev) =>
      prev.map((c) =>
        c.id === item.id
          ? {
              ...c,
              qty,
              calculated_total: calculateItemTotal(c, qty, unit),
            }
          : c,
      ),
    );
  };
  const handleBlur = (item, unit) => {
    setCart((prev) =>
      prev.map((c) => {
        if (c.id !== item.id) return c;

        const minValue = Number(unit.unit_qty || 1);
        let finalQty = Number(c.qty);

        if (!finalQty || finalQty < minValue) {
          finalQty = minValue;
        }

        return {
          ...c,
          qty: finalQty,
          calculated_total: calculateItemTotal(c, finalQty, unit),
        };
      }),
    );
  };

  useEffect(() => {
    const synced = {};

    cart.forEach((item) => {
      if (item.qty !== undefined) {
        synced[item.id] = item.qty;
      }
    });

    setInputValues((prev) => ({
      ...prev,
      ...synced,
    }));
  }, [cart]);

  // -------------------- UNIT CHANGE --------------------

  // const handleUnitChange = (item, newUnit) => {
  //   setCart((prev) =>
  //     prev.map((c) => {
  //       if (c.id !== item.id) return c;

  //       const qty = c.qty || 1;

  //       const updated = {
  //         ...c,
  //         variant_id: newUnit.variant_id,
  //         unit_name: newUnit.unit_name,
  //         unit_qty: newUnit.unit_qty,
  //         unit_short_name: newUnit.short_name,
  //         selling_price: Number(newUnit.selling_price),
  //         manual_total: null,
  //       };

  //       return {
  //         ...updated,
  //         calculated_total: calculateItemTotal(updated, qty, newUnit),
  //       };
  //     }),
  //   );

  //   setSelectedUnits((prev) => ({
  //     ...prev,
  //     [item.id]: newUnit,
  //   }));

  //   setOpenDropdownId(null);
  // };

  const handleUnitChange = (item, newUnit) => {
    const newQty = Number(newUnit.unit_qty || 1);

    setInputValues((prev) => ({
      ...prev,
      [item.id]: String(newQty),
    }));

    setCart((prev) =>
      prev.map((c) => {
        if (c.id !== item.id) return c;

        const updated = {
          ...c,
          variant_id: newUnit.variant_id,
          unit_name: newUnit.unit_name,
          unit_qty: newUnit.unit_qty,
          unit_short_name: newUnit.short_name,
          selling_price: Number(newUnit.selling_price),
          qty: newQty,
          manual_total: null,
          unit_id: newUnit.unit_id,
        };

        return {
          ...updated,
          calculated_total: calculateItemTotal(updated, newQty, newUnit),
        };
      }),
    );

    setSelectedUnits((prev) => ({
      ...prev,
      [item.id]: newUnit,
    }));

    setOpenDropdownId(null);
  };

  const removeItem = (item) => {
    setCart((prev) =>
      prev.filter((c) => !(c.id === item.id && c.variant_id === item.variant_id)),
    );

    setInputValues((prev) => {
      const updated = { ...prev };
      delete updated[item.id];
      return updated;
    });
  };

  const validateField = (name, value) => {
    switch (name) {
      case "name":
        if (!value) return t("nameIsRequired");
        return "";

      case "mobile":
        if (!value) return t("mobileIsRequired");
        const mobileRegex = /^\d{10}$/;
        if (!mobileRegex.test(value)) {
          return t("enterDigitMobileNumber");
        }
        return "";

      default:
        return "";
    }
  };

  const handleAddCustomer = async (e) => {
    e.preventDefault();
    const newErrors = {
      name: validateField("name", newCustomer.name),
      mobile: validateField("mobile", newCustomer.mobile),
    };
    Utils.focusError();
    setErrors(newErrors);
    const hasErrors = Object.values(newErrors).some((err) => err);

    if (hasErrors) {
      if (newErrors.name) {
        nameRef.current?.focus();
      } else if (newErrors.mobile) {
        mobileRef.current?.focus();
      }
      return;
    }
    let data = {
      name: newCustomer?.name,
      mobile: newCustomer?.mobile,
      store_id: storedData?.active_store_id,
    };
    try {
      setIsSubmitting(true);
      const response = await createCustomerSerachStoreOwner(data);
      const decrypted = decryptData(response.data.data);
      notify.success(decrypted.message);
      fetchCustomerData();
      setCustomerData(decrypted.data);
      setQuery(newCustomer.mobile);
      setNewCustomer({ name: "", mobile: "" });
      setIsAddModalOpen(false);
      setIsSubmitting(false);
      setErrors({
        name: "",
        mobile: "",
      });
    } catch (err) {
      notify.error(Utils.getErrorMessage(err));

      setIsSubmitting(false);
    }
  };

  const handleOrderSubmit = async (e) => {
    if (!customerData) {
      return notify.error("Please select customer");
    }

    const invalidItem = cart.find((item) => {
      const unit = item.units?.find((u) => u.variant_id === item.variant_id);
      const minValue = Number(unit?.unit_qty || 1);

      return Number(item.qty) < minValue;
    });

    if (invalidItem) {
      const unit = invalidItem.units?.find(
        (u) => u.variant_id === invalidItem.variant_id,
      );

      return notify.error(
        `Minimum quantity for ${invalidItem.name} is ${unit?.unit_qty}${unit.short_name}`,
      );
    }

    setOrderModel(true);
  };

  useEffect(() => {
    if (customerData?.mobile) {
      setQuery(customerData.mobile);
      setSelectedCustomer(customerData);
    }
  }, [customerData]);

  const updateCartItemPrice = (id, value) => {
    setCart((prev) =>
      prev.map((c) => {
        if (c.id !== id) return c;

        const newPrice = value === "" ? "" : Number(value);
        const qty = c.qty || 1;

        const unit =
          selectedUnits?.[c.id] ||
          c.units?.find((u) => u.variant_id === c.variant_id) ||
          c.units?.[0];

        const updated = {
          ...c,
          custom_price: newPrice,
          manual_total: null,
        };

        return {
          ...updated,
          calculated_total: calculateItemTotal(updated, qty, unit),
        };
      }),
    );
  };

  const getEffectivePrice = (item) => {
    return item.custom_price !== null &&
      item.custom_price !== undefined &&
      item.custom_price !== ""
      ? Number(item.custom_price)
      : Number(item.selling_price || 0);
  };

  const calculateItemTotal = (item, qty, unit) => {
    if (!unit || !qty) return 0;

    const price = getEffectivePrice(item);

    const baseQty = Number(unit.unit_qty || 1);

    return Number(((qty * price) / baseQty).toFixed(2));
  };

  const getGrandTotal = (cart) => {
    return cart.reduce((sum, item) => {
      const qty = item.qty || 0;
      const unit =
        item.units?.find((u) => u.variant_id === item.variant_id) ||
        item.units?.find((u) => u.default_unit === 1) ||
        item.units?.[0];

      const autoTotal = calculateItemTotal(item, qty, unit);

      const finalTotal =
        item.manual_total !== null && item.manual_total !== undefined
          ? Number(item.manual_total)
          : (item.calculated_total ?? autoTotal);

      return sum + Number(finalTotal || 0);
    }, 0);
  };

  const totalPrice = getGrandTotal(cart);

  const getFinalTotal = (item, qty, unit) => {
    if (item.manual_total !== null && item.manual_total !== undefined) {
      return Number(item.manual_total);
    }

    return calculateItemTotal(item, qty, unit);
  };

  return (
    <div className="w-full bg-[#FDFCFB] dark:bg-[#050C1A] transition-colors duration-300">
      {/* <div className="max-w-[1400px] mx-auto p-4 md:p-6 lg:px-10 flex items-center justify-between hidden md:flex">
        <div className="flex items-center gap-4">
          <button
            onClick={() => {
              localStorage.removeItem("storeOwnerCart");
              setCart([]);
              navigate("/dashboard");
            }}
            className="p-2 hover:bg-gray-100 dark:hover:bg-slate-800 rounded-full transition-colors"
            aria-label="Go back"
          >
            <ChevronLeft size={24} />
          </button>

          <div className="flex flex-col">
            <h1 className="text-2xl md:text-3xl font-black text-gray-900 dark:text-white tracking-tight">
              {t("createNewOrder")}
            </h1>
            <p className="text-gray-500 dark:text-slate-400 font-medium hidden md:block">
              {t("customerInCart")}
            </p>
          </div>
        </div>
      </div> */}

      <header className="bg-[#E67E22] p-5 flex items-center gap-4 shadow-lg hidden md:flex shrink-0">
        <button
          onClick={() => {
            localStorage.removeItem("storeOwnerCart");
            setCart([]);
            navigate("/dashboard");
          }}
          className="w-10 h-10 rounded-full bg-white dark:bg-slate-800 flex items-center justify-center text-slate-800 dark:text-white"
        >
          <ChevronLeft size={20} />
        </button>
        <h1 className="text-white font-black text-xl">{t("createNewOrder")}</h1>
      </header>

      {/* <div className="flex-1 overflow-y-auto px-4 md:px-6 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4"></div>
      </div> */}

      <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-4 md:gap-8 pb-32 md:pb-10 md:mt-4">
        <div className="lg:col-span-7 xl:col-span-8 space-y-4 md:space-y-6">
          <div className="bg-white dark:bg-[#0A1221] p-4 md:p-10 rounded-[2rem] shadow-sm border border-slate-100 dark:border-slate-800">
            <div className="relative mb-6 md:mb-10" ref={wrapperRef}>
              <label className="text-[10px] font-black uppercase tracking-[0.15em] text-slate-400 mb-2 block ml-1">
                {t("selectCustomer")}
              </label>
              <div className="relative group">
                <Person
                  className="absolute left-4 top-1/2 -translate-y-1/2 text-orange-500 transition-transform group-focus-within:scale-110"
                  size={18}
                />

                <input
                  value={
                    selectedCustomer
                      ? `${selectedCustomer.name} - ${selectedCustomer.mobile}`
                      : query
                  }
                  onChange={handleCustomerInput}
                  placeholder={t("searchByMobileName")}
                  className="w-full pl-12 pr-10 py-3.5 md:py-5 border-2 border-slate-50 dark:border-slate-800 bg-[#F8FAFC] dark:bg-[#050C1A] rounded-2xl text-slate-800 dark:text-white font-bold outline-none focus:border-orange-500 focus:bg-white transition-all text-sm md:text-lg shadow-inner"
                />

                {query && (
                  <button
                    onClick={() => {
                      setQuery("");
                      setIsOpen(false);
                      setCustomerData("");
                      localStorage.removeItem("customerStoreOwnerData");
                      setSelectedCustomer(null);
                    }}
                    className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 dark:text-slate-500 hover:text-red-500 transition"
                  >
                    ✕
                  </button>
                )}
              </div>

              {isOpen && (
                <div className="absolute top-[calc(100%+8px)] left-0 right-0 bg-white dark:bg-[#0F172A] border border-slate-100 dark:border-slate-800 rounded-2xl shadow-2xl z-50 overflow-hidden animate-in fade-in slide-in-from-top-2">
                  <div className="max-h-60 overflow-y-auto">
                    {customerList?.length > 0 ? (
                      customerList?.map((c) => (
                        <div
                          key={c.id}
                          onClick={() => handleSelectCustomer(c)}
                          className="px-5 py-3 hover:bg-orange-50 dark:hover:bg-orange-500/10 cursor-pointer border-b border-slate-50 dark:border-slate-800 last:border-0 flex items-center justify-between group"
                        >
                          <div className="flex items-center gap-3">
                            <div className="w-9 h-9 rounded-full bg-orange-100 dark:bg-orange-900/30 flex items-center justify-center font-black text-orange-600 text-xs">
                              {c.profile_image ? (
                                <img
                                  src={c.profile_image}
                                  alt={c.name}
                                  className="w-full h-full object-cover"
                                />
                              ) : (
                                <span className="text-orange-500 font-black text-lg">
                                  {c.name.charAt(0)}
                                </span>
                              )}
                            </div>

                            {/* Customer Name and Mobile (Optional but user-friendly) */}
                            <div className="flex flex-col">
                              <span className="font-bold text-slate-800 dark:text-slate-200 text-sm group-hover:text-orange-600 transition-colors">
                                {c.name}
                              </span>

                              {c.mobile && (
                                <span className="text-[9px] font-bold text-slate-400 uppercase">
                                  {c.mobile}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="p-6 text-center">
                        <p className="text-gray-400 dark:text-slate-500 mb-4">
                          {t("noCustomerMatched")}
                        </p>
                        <button
                          onClick={() => {
                            setIsAddModalOpen(true);
                            setIsOpen(false);

                            let name = "";
                            let mobile = "";

                            if (selectedCustomer) {
                              // if selected from list
                              name = selectedCustomer.name;
                              mobile = selectedCustomer.mobile;
                            } else if (query) {
                              // if user typed manually
                              if (isMobileInput(query)) {
                                mobile = query;
                              } else {
                                name = query;
                              }
                            }

                            setNewCustomer({
                              name,
                              mobile,
                            });
                          }}
                          className="flex items-center justify-center gap-2 w-full py-3 bg-orange-50 dark:bg-orange-500/10 text-orange-600 dark:text-orange-400 rounded-xl font-bold hover:bg-orange-100 dark:hover:bg-orange-500/20 transition-all"
                        >
                          <Plus size={20} /> {t("addNewCustomer")}
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>

            {/* Product Section */}
            <div className="relative">
              <label className="text-[10px] font-black uppercase tracking-[0.15em] text-slate-400 mb-2 block ml-1">
                {t("addProductsToCart")}
              </label>
              <div className="relative group">
                <Search
                  className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 group-focus-within:text-orange-500 transition-all"
                  size={18}
                />

                <input
                  value={productQuery}
                  onChange={(e) => setProductQuery(e.target.value)}
                  placeholder={t("searchByProductName")}
                  className="w-full pl-12 pr-6 py-3.5 md:py-5 bg-[#F8FAFC] dark:bg-[#050C1A] border-2 border-transparent dark:border-slate-800 rounded-2xl outline-none focus:border-orange-500 focus:bg-white transition-all text-slate-800 dark:text-white font-bold text-sm md:text-lg shadow-inner"
                />
              </div>

              {productQuery && (
                <div className="absolute top-[calc(100%+8px)] left-0 right-0 bg-white dark:bg-[#0F172A] border border-slate-100 dark:border-slate-800 rounded-2xl shadow-2xl z-40 max-h-80 overflow-y-auto p-1.5">
                  {productList
                    .filter((p) =>
                      p.name.toLowerCase().includes(productQuery.toLowerCase()),
                    )
                    .map((item, index) => {
                      return (
                        <React.Fragment key={index}>
                          <div
                            onClick={() => addToCart(item)}
                            className="flex justify-between items-center px-4 py-2.5 hover:bg-orange-50 dark:hover:bg-orange-500/10 rounded-xl cursor-pointer transition-colors"
                          >
                            <div className="flex items-center gap-3">
                              <span className="text-lg">
                                {item.icon || "📦"}
                              </span>
                              <div>
                                <p className="font-bold text-xs md:text-sm text-slate-800 dark:text-slate-200">
                                  {item.name}
                                </p>
                                <p className="text-[9px] text-slate-400 font-bold uppercase">
                                  {item.unit_qty} {item.unit_short_name}
                                </p>
                              </div>
                            </div>
                            <div className="flex items-center gap-3">
                              <span className="text-orange-600 dark:text-orange-400 font-black text-xs md:text-sm">
                                {formatCurrencyINR(item.selling_price)}
                              </span>
                              <div className="bg-orange-500 text-white p-1 rounded-lg shadow-md">
                                <Plus size={14} strokeWidth={3} />
                              </div>
                            </div>
                          </div>
                        </React.Fragment>
                      );
                    })}
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="lg:col-span-5 xl:col-span-4 lg:sticky lg:top-8">
          <div className="bg-white dark:bg-[#0A1221] rounded-[2rem] shadow-xl border border-slate-50 dark:border-slate-800 overflow-hidden flex flex-col h-full lg:max-h-[calc(700px-5rem)]">
            <div className="p-4 border-b border-slate-50 dark:border-slate-800 flex justify-between items-center bg-[#FCFDFF] dark:bg-[#050C1A]">
              <h2 className="font-black text-sm uppercase tracking-widest text-slate-800 dark:text-white">
                {t("yourCart")}
              </h2>
              <span className="bg-orange-100 dark:bg-orange-950/40 text-orange-600 text-[10px] font-black px-2.5 py-1 rounded-full">
                {cart?.length} {t("items")}
              </span>
            </div>

            <div className="flex-1 overflow-y-auto p-3 space-y-2 scrollbar-hide min-h-[200px]">
              {cart?.length === 0 ? (
                <div className="py-12 text-center">
                  <Cart3 size={32} className="text-slate-200 mx-auto mb-2" />
                  <p className="text-slate-400 text-[10px] font-bold italic">
                    {t("noItemsAddedToCart")}
                  </p>
                </div>
              ) : (
                cart?.map((item) => {
                  const isDropdownOpen = openDropdownId === item.id;
                  const units = item?.units || [];

                  const currentUnit = item.variant_id
                    ? units.find((u) => u.variant_id === item.variant_id)
                    : units.find((u) => u.default_unit === 1) || units[0] || {};

                  const qty = inputValues[item.id] ?? item.qty ?? 0;
                  const total = getFinalTotal(item, qty, currentUnit);

                  return (
                    <div
                      key={`${item.id}-${item.variant_id}`}
                      className="p-3.5 rounded-2xl border border-slate-50 dark:border-slate-800 bg-[#FCFDFF] dark:bg-[#050C1A] relative shadow-sm group"
                    >
                      <button
                        onClick={() => removeItem(item)}
                        className="absolute top-2 right-2 text-gray-300 dark:text-slate-600 hover:text-red-500"
                      >
                        <X size={22} />
                      </button>
                      <p className="font-bold text-gray-800 dark:text-slate-200 mb-4 pr-6">
                        {item.icon || "📦"} {item.name} ({item?.unit_qty}
                        {item?.unit_short_name})
                      </p>
                      <div className="flex items-center gap-2 w-full bg-white dark:bg-slate-900 p-1.5 rounded-2xl border border-slate-100 dark:border-slate-800 shadow-sm">
                        <div className="flex items-center gap-2 w-full bg-slate-50/50 dark:bg-slate-800/40 p-1 rounded-[22px] border border-slate-100 dark:border-slate-800 shadow-sm">
                          <div className="relative flex-[0.8] min-w-[70px]">
                            {" "}
                            <span className="absolute left-2 top-1/2 -translate-y-1/2 text-zinc-400 text-xs font-bold">
                              {configData?.COUNTRY_CURRENCY}
                            </span>
                            <input
                              type="number"
                              inputMode="decimal"
                              value={
                                item.custom_price !== null &&
                                item.custom_price !== undefined &&
                                item.custom_price !== ""
                                  ? item.custom_price
                                  : ""
                              }
                              onChange={(e) => {
                                const value = e.target.value.replace(
                                  /[^0-9.]/g,
                                  "",
                                );
                                updateCartItemPrice(item.id, value);
                              }}
                              className="w-full pl-7 pr-3 py-3 bg-white dark:bg-slate-900 border border-slate-100 dark:border-slate-800 rounded-2xl text-sm font-bold text-zinc-700 dark:text-slate-200 shadow-sm focus:border-orange-500/50 focus:ring-4 focus:ring-orange-500/5 transition-all outline-none text-center"
                              placeholder={item.selling_price}
                            />
                          </div>

                          {/* <p>Price: ₹{currentUnit.selling_price}</p> */}

                          <div className="flex-1 min-w-[100px] relative group/qty">
                            <div className="flex items-center bg-slate-50 dark:bg-slate-800/50 border border-slate-100 dark:border-slate-800 rounded-2xl p-1.5 w-full shadow-inner">
                              <button
                                onClick={() =>
                                  updateCart(item, -1, currentUnit)
                                }
                                className={`flex h-8 w-8 items-center justify-center rounded-xl shadow-sm transition-transform active:scale-90
                                    ${
                                      qty <= currentUnit.unit_qty
                                        ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                                        : "bg-white dark:bg-slate-700 text-orange-600"
                                    }
                                  `}
                                disabled={qty <= currentUnit.unit_qty}
                              >
                                <Dash size={20} strokeWidth={3} />
                              </button>

                              <input
                                type="text"
                                inputMode="numeric"
                                maxLength={6}
                                value={inputValues[item.id] ?? qty ?? ""}
                                onChange={(e) =>
                                  handleCartQtyInput(
                                    item,
                                    currentUnit,
                                    e.target.value.replace(/[^0-9]/g, ""),
                                  )
                                }
                                onBlur={() => handleBlur(item, currentUnit)}
                                onTouchEnd={() => handleBlur(item, currentUnit)}
                                onKeyUp={(e) => {
                                  if (e.key === "Enter")
                                    handleBlur(item, currentUnit);
                                }}
                                className="text-center font-black text-base w-full bg-transparent focus:outline-none"
                              />

                              <button
                                onClick={() => updateCart(item, 1, currentUnit)}
                                className="flex h-8 w-8 items-center justify-center bg-orange-500 rounded-xl text-white shadow-md shadow-orange-500/20 active:scale-90 transition-transform"
                              >
                                <Plus size={20} strokeWidth={3} />
                              </button>
                            </div>

                            {currentUnit?.unit_qty &&
                              qty < currentUnit.unit_qty && (
                                <div
                                  className="absolute top-full mt-1 left-1/2 -translate-x-1/2
                                  bg-gray-800 text-white text-[9px] px-2 py-0.5 rounded-md
                                  z-50 whitespace-nowrap pointer-events-none shadow-lg"
                                >
                                  Min: {currentUnit.unit_qty}
                                  <div
                                    className="absolute -top-1 left-1/2 -translate-x-1/2
                                    border-l-4 border-l-transparent
                                    border-r-4 border-r-transparent
                                    border-b-4 border-b-gray-800"
                                  ></div>
                                </div>
                              )}
                          </div>
                        </div>

                        {units?.length > 1 && (
                          <div className="relative flex-[0.7]">
                            <button
                              onClick={() =>
                                setOpenDropdownId(
                                  isDropdownOpen ? null : item.id,
                                )
                              }
                              className="w-full flex items-center justify-center gap-1 bg-white dark:bg-slate-800 text-zinc-500 dark:text-zinc-400 text-[9px] font-black px-2 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 hover:border-orange-300 transition-all uppercase truncate"
                            >
                              {currentUnit.unit_name}
                              <ChevronDown
                                size={12}
                                className={`transition-transform ${
                                  isDropdownOpen ? "rotate-180" : ""
                                }`}
                              />
                            </button>
                            {isDropdownOpen && (
                              <>
                                <div
                                  className="fixed inset-0 z-40"
                                  onClick={() => setOpenDropdownId(null)}
                                />
                                <div className="absolute right-0 top-full mt-2 w-40 bg-white border border-orange-100 rounded-2xl shadow-xl z-50 animate-in fade-in zoom-in-95 duration-150 origin-top-right">
                                  <div className="absolute -top-1.5 right-6 w-3 h-3 bg-white border-t border-l border-orange-100 rotate-45" />

                                  <div className="p-1.5 space-y-1">
                                    {units.map((u) => {
                                      const isSelected =
                                        currentUnit.variant_id === u.variant_id;
                                      return (
                                        <button
                                          key={u.variant_id}
                                          onClick={() =>
                                            handleUnitChange(item, u)
                                          }
                                          className={`w-full flex items-center justify-between px-3 py-2.5 rounded-xl transition-all duration-200 ${
                                            isSelected
                                              ? "bg-orange-500 text-white shadow-md shadow-orange-200"
                                              : "text-zinc-700 hover:bg-orange-50 hover:text-orange-600"
                                          }`}
                                        >
                                          <div className="flex flex-col items-start leading-tight">
                                            <span
                                              className={`text-[10px] font-black uppercase tracking-wider ${
                                                isSelected
                                                  ? "text-white"
                                                  : "text-zinc-900"
                                              }`}
                                            >
                                              {u.unit_name}
                                            </span>
                                            <span
                                              className={`text-[9px] font-bold mt-0.5 ${
                                                isSelected
                                                  ? "text-orange-100/80"
                                                  : "text-zinc-400"
                                              }`}
                                            >
                                              {t("Pk")}: {u.unit_qty}
                                            </span>
                                          </div>
                                          <div className="flex flex-col items-end leading-tight">
                                            <span
                                              className={`text-xs font-black ${
                                                isSelected
                                                  ? "text-white"
                                                  : "text-orange-600"
                                              }`}
                                            >
                                              {formatCurrencyINR(
                                                u.selling_price || 0,
                                              )}
                                            </span>
                                            {isSelected && (
                                              <span className="text-[7px] font-black uppercase text-orange-200 tracking-tighter">
                                                Active
                                              </span>
                                            )}
                                          </div>
                                        </button>
                                      );
                                    })}
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        )}
                      </div>
                      <div className="mt-4 flex justify-between items-center border-t border-dashed border-gray-100 pt-3">
                        <span className="text-gray-400 dark:text-slate-500 text-xs font-bold uppercase">
                          {t("productTotal")}
                        </span>
                        <span className="text-gray-900 dark:text-slate-200 font-black">
                          <div className="relative flex-[0.8] min-w-[70px]">
                            <span className="absolute left-2 top-1/2 -translate-y-1/2 text-zinc-400 text-xs font-bold">
                              {configData?.COUNTRY_CURRENCY}
                            </span>

                            <input
                              type="number"
                              inputMode="decimal"
                              value={
                                item.manual_total !== null &&
                                item.manual_total !== undefined
                                  ? item.manual_total
                                  : ""
                              }
                              placeholder={total}
                              // onChange={(e) => {
                              //   const value = e.target.value.replace(/\D/g, "");
                              //   updateSubtotal(item.id, value);
                              // }}
                              onChange={(e) => {
                                let value = e.target.value;
                                if (/^\d*\.?\d*$/.test(value)) {
                                  updateSubtotal(item.id, value);
                                }
                              }}
                              className="w-[155px] pl-7 pr-3 py-3 bg-white dark:bg-slate-900 border border-slate-100 dark:border-slate-800 rounded-2xl text-sm font-bold text-center dark:text-slate-200 shadow-sm focus:border-orange-500/50 focus:ring-4 focus:ring-orange-500/5 transition-all outline-none text-center"
                            />
                          </div>
                        </span>
                      </div>
                    </div>
                  );
                })
              )}
            </div>

            {totalPrice > 0 && (
              <div
                className="p-4 md:p-6 bg-white dark:bg-[#0A1221] border-t border-slate-100 dark:border-slate-800 shadow-[0_-10px_30px_rgba(0,0,0,0.03)] 
                        fixed bottom-0 left-0 right-0 z-[60] md:relative md:shadow-none"
              >
                <div className="flex flex-row md:flex-col lg:flex-row items-center justify-between gap-4">
                  <div className="flex flex-col">
                    <span className="text-[9px] md:text-[10px] font-black text-slate-400 uppercase tracking-widest">
                      {t("grandTotal")}
                    </span>
                    <span className="text-xl md:text-3xl font-black text-slate-900 dark:text-white tracking-tighter">
                      {formatCurrencyINR(totalPrice || 0)}
                    </span>
                  </div>
                  <button
                    onClick={handleOrderSubmit}
                    className="flex-1 md:w-full  bg-[#FF7A1A] hover:bg-[#e66a00] dark:bg-orange-600 text-white py-3.5 md:py-4 px-6 rounded-2xl font-black text-sm md:text-lg shadow-lg shadow-slate-200 dark:shadow-none active:scale-95 transition-all flex items-center justify-center gap-2"
                  >
                    {t("generateOrder")}{" "}
                    <ChevronRight size={18} strokeWidth={3} />
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {isAddModalOpen && (
        <div className="fixed inset-0 z-[100] flex items-end md:items-center justify-center p-0 md:p-4">
          <div
            className="absolute inset-0 bg-black/40 backdrop-blur-md"
            onClick={() => setIsAddModalOpen(false)}
          />
          <div className="relative w-full max-w-md bg-white dark:bg-[#0A1221] rounded-t-[2.5rem] md:rounded-[2rem] shadow-2xl overflow-hidden animate-in slide-in-from-bottom duration-300">
            <div className="p-8 border-b dark:border-slate-800 flex justify-between items-center bg-gray-50/50 dark:bg-[#0F172A]/50">
              <h3 className="text-2xl font-black text-gray-900 dark:text-white">
                {t("newCustomer")}
              </h3>
              <button
                onClick={() => setIsAddModalOpen(false)}
                className="p-2 hover:bg-gray-200 rounded-full transition-colors"
              >
                <X size={28} />
              </button>
            </div>

            <form onSubmit={handleAddCustomer} className="p-8 space-y-6">
              <div>
                <label className="text-xs font-black text-gray-400 dark:text-slate-500 uppercase tracking-widest mb-2 block">
                  {t("fullName")}
                </label>
                <div className="relative group">
                  <Person className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 dark:text-slate-600" />
                  <input
                    type="text"
                    autoFocus
                    ref={nameRef}
                    value={newCustomer.name}
                    onChange={(e) =>
                      setNewCustomer({ ...newCustomer, name: e.target.value })
                    }
                    placeholder={t("enterName")}
                    className="w-full pl-12 pr-4 py-4 bg-gray-50 dark:bg-[#050C1A] border-2 border-gray-100 dark:border-slate-800 rounded-2xl focus:border-orange-500 outline-none transition-all font-bold dark:text-white"
                    maxLength={30}
                  />
                </div>
                {errors.name && (
                  <span className={`text-danger mt-1`}>{errors.name}</span>
                )}
              </div>

              <div>
                <label className="text-xs font-black text-gray-400 dark:text-slate-500 uppercase tracking-widest mb-2 block">
                  {t("mobileNumber")}{" "}
                </label>
                <div className="relative group">
                  <Phone className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 dark:text-slate-600" />
                  <input
                    type="text"
                    inputMode="numeric"
                    ref={mobileRef}
                    autoFocus
                    value={newCustomer.mobile}
                    onChange={(e) => {
                      const value = e.target.value
                        .replace(/\D/g, "")
                        .slice(0, 10);

                      setNewCustomer((prev) => ({
                        ...prev,
                        mobile: value,
                      }));
                    }}
                    placeholder={t("enterMobileNumber")}
                    className="w-full pl-12 pr-4 py-4 bg-gray-50 dark:bg-[#050C1A] border-2 border-gray-100 dark:border-slate-800 rounded-2xl focus:border-orange-500 outline-none transition-all font-bold dark:text-white"
                    onKeyDown={(e) =>
                      ["e", "E", "+", "-", "."].includes(e.key) &&
                      e.preventDefault()
                    }
                  />
                </div>
                {errors.mobile && (
                  <span className={`text-danger mt-1`}>{errors.mobile}</span>
                )}
              </div>

              <div className="pt-4 grid grid-cols-2 gap-4">
                <button
                  type="button"
                  onClick={() => setIsAddModalOpen(false)}
                  className="py-4 border-2 border-gray-100 dark:border-slate-800 rounded-2xl font-black text-gray-400 dark:text-slate-500 hover:bg-gray-50 dark:hover:bg-slate-800"
                >
                  {t("cancel")}
                </button>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="py-4 bg-orange-600 hover:bg-orange-700 text-white rounded-2xl font-black shadow-lg shadow-orange-100 flex items-center justify-center gap-2"
                >
                  {isSubmitting ? (
                    "Saving..."
                  ) : (
                    <>
                      <Check2 size={24} /> {t("save")}
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default NewOrderStoreCard;
